// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__mpxVy","productName":"Table_productName__3UlQu"};